export type TStoryBlokKlaviyoFormType = "SECTION" | "MODAL";
export type TKlaviyoFormModalPopupOn = "PAGE_LOAD" | "SCROLL_DEPTH_HIT" | "EXIT_INTENT";

interface IBaseStoryBlokKlaviyoForm {
  formId: string;
  displayType: TStoryBlokKlaviyoFormType;
  featureFlagId?: string;
  featureFlagValue?: string;
}

export interface IStoryBlokKlaviyoFormModal extends IBaseStoryBlokKlaviyoForm {
  displayType: "MODAL";
  delay?: number;
  popupOn?: TKlaviyoFormModalPopupOn;
  daysUntilCanShowAgain?: number;
}

export interface IStoryBlokKlaviyoFormSection extends IBaseStoryBlokKlaviyoForm {
  displayType: "SECTION";
}

export type TStoryBlokKlaviyoForm = IStoryBlokKlaviyoFormModal | IStoryBlokKlaviyoFormSection;

export const isModalKlaviyoForm = (form: TStoryBlokKlaviyoForm): form is IStoryBlokKlaviyoFormModal => form.displayType === "MODAL";

export const isSectionKlaviyoForm = (form: TStoryBlokKlaviyoForm): form is IStoryBlokKlaviyoFormSection => form.displayType === "SECTION";

export const isKlaviyoFormPartOfExperiment = (form: TStoryBlokKlaviyoForm): form is TStoryBlokKlaviyoForm & {
  featureFlagId?: string,
  featureFlagValue?: string
} => !!(!!form.featureFlagId && !!form.featureFlagValue);
